import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from 'react-router-dom';
import { config } from './config'
import { GlobalContextProvider } from './store/global-context'

const root = ReactDOM.createRoot(document.getElementById('root'));

const oidcConfig = config.oidcConfig;

root.render(
  // <React.StrictMode>
  <GlobalContextProvider>
    <BrowserRouter basename='SupplyOrder'>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </GlobalContextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
